import * as React from "react"

const IconChair = ({ height, width, color }) => (
    <svg height={height} width={width} viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
        <g
            clipPath="url(#clip0_129_128)"
            fill={color ?? "#1A327D"}
            stroke={color ?? "#1A327D"}
        >
            <path
                fill={color ?? "#1A327D"}
                stroke={color ?? "#1A327D"}
                d="M42.75 43.875V32.625C42.75 28.9035 45.7785 25.875 49.5 25.875C50.742 25.875 51.75 26.883 51.75 28.125C51.75 29.376 50.7285 30.3908 49.473 30.375C48.24 30.3592 47.25 31.392 47.25 32.625V39.375C47.25 41.8613 45.2363 43.875 42.75 43.875Z"
            />
            <path
                fill={color ?? "#1A327D"}
                stroke={color ?? "#1A327D"}
                d="M11.25 43.875V32.625C11.25 28.9035 8.2215 25.875 4.5 25.875C3.258 25.875 2.25 26.883 2.25 28.125C2.25 29.376 3.2715 30.3908 4.527 30.375C5.76 30.3592 6.75 31.392 6.75 32.625V39.375C6.75 41.8613 8.76375 43.875 11.25 43.875Z"
            />
            <path
                fill={color ?? "#1A327D"}
                stroke={color ?? "#1A327D"}
                d="M36.5625 54H17.4375C16.1955 54 15.1875 52.992 15.1875 51.75C15.1875 50.508 16.1955 49.5 17.4375 49.5H36.5625C37.8045 49.5 38.8125 50.508 38.8125 51.75C38.8125 52.992 37.8045 54 36.5625 54Z"
            />
            <path
                fill={color ?? "#1A327D"}
                stroke={color ?? "#1A327D"}
                d="M27 54C25.758 54 24.75 52.992 24.75 51.75V42.1875C24.75 40.9455 25.758 39.9375 27 39.9375C28.242 39.9375 29.25 40.9455 29.25 42.1875V51.75C29.25 52.992 28.242 54 27 54Z"
            />
            <path
                fill={color ?? "#1A327D"}
                stroke={color ?? "#1A327D"}
                d="M38.3863 29.25H15.6118C14.4463 29.25 13.3483 28.737 12.599 27.846C11.8475 26.955 11.5325 25.785 11.7328 24.6375L15.4498 3.2625C15.7783 1.3725 17.4095 0 19.3288 0H34.667C36.5885 0 38.2198 1.3725 38.546 3.26475L42.263 24.6398C42.4633 25.7873 42.1483 26.9573 41.3968 27.8483C40.6498 28.737 39.5518 29.25 38.3863 29.25V29.25Z"
            />
            <path
                fill={color ?? "#1A327D"}
                stroke={color ?? "#1A327D"}
                d="M43.3125 43.875H10.6875C9.756 43.875 9 43.119 9 42.1875V37.6875C9 34.2743 11.7743 31.5 15.1875 31.5H38.8125C42.2257 31.5 45 34.2743 45 37.6875V42.1875C45 43.119 44.244 43.875 43.3125 43.875Z"
            />
        </g>
        <defs>
            <clipPath id="clip0_129_128">
                <rect width={54} height={54} fill="white" />
            </clipPath>
        </defs>
    </svg>
)
export default IconChair
